import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SelectGroup from '@/components/molecules/select/SelectGroup.vue';
import { IFilterField } from './types';

interface Props {
    field: IFilterField;
    value: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSelectField',
  props: {
    field: null,
    value: null
  },
  emits: ["update"],
  setup(__props: any) {

const props = __props as {
    field: IFilterField;
    value: any;
};





const computedOptions = computed(() => {
    if (!props.field.options) return [];
    return typeof props.field.options === 'function' 
        ? props.field.options() 
        : props.field.options;
});


return { __sfc: true,props, computedOptions, SelectGroup }
}

})